import React from 'react';
import { ArrowRight, Sparkles, TrendingUp } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-background-image"></div>
      <div className="hero-overlay"></div>
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-badge">
            <Sparkles className="badge-icon" size={16} />
            <span>Complete Business Solutions</span>
          </div>
          
          <h1 className="hero-title">
            Do you already own a business?
            <br />
            <span className="hero-title-highlight">Or are you planning to start a new company</span>
            <br />
            but unsure where to begin?
          </h1>
          
          <div className="hero-description-box">
            <div className="hero-description-accent"></div>
            <p className="hero-description-main">
              <span className="highlight-text">MilaMia manages the entire process for you</span> — from logo design to website development, and from corporate identity to your complete digital presence.
            </p>
            <p className="hero-description-cta">
              <span className="cta-icon">✨</span>
              <strong>Build your brand on the right foundation.</strong>
            </p>
          </div>
          
          <div className="hero-cta">
            <Button
              size="lg"
              className="hero-primary-button"
              onClick={() => scrollToSection('services')}
            >
              Explore Our Services
              <ArrowRight className="button-icon" size={20} />
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="hero-secondary-button"
              onClick={() => scrollToSection('contact')}
            >
              Get Started Today
            </Button>
          </div>
          
          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-icon-wrapper">
                <TrendingUp className="stat-icon" size={24} />
              </div>
              <div className="stat-content">
                <div className="stat-value">98%</div>
                <div className="stat-label">Client Satisfaction</div>
              </div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <div className="stat-icon-wrapper">
                <Sparkles className="stat-icon" size={24} />
              </div>
              <div className="stat-content">
                <div className="stat-value">24/7</div>
                <div className="stat-label">AI Support</div>
              </div>
            </div>
            <div className="stat-divider"></div>
            <div className="stat-item">
              <div className="stat-icon-wrapper">
                <TrendingUp className="stat-icon" size={24} />
              </div>
              <div className="stat-content">
                <div className="stat-value">20+</div>
                <div className="stat-label">Global Clients</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;